export var MediumCta;
(function (MediumCta) {
    MediumCta["ESTIMATE"] = "estimate_a_property";
    MediumCta["AUTO_COMPLETE"] = "auto_suggest";
    MediumCta["LINK_BOXES"] = "link_boxes";
    MediumCta["SWITCH_MAP_VIEW"] = "switch_map_view";
    MediumCta["SWITCH_INFO_VIEW"] = "switch_info_view";
    MediumCta["CREATE_LISTING"] = "create_listing";
    MediumCta["BREADCRUMB"] = "breadcrumb";
    MediumCta["MAP"] = "map";
    MediumCta["CHECK"] = "check";
})(MediumCta || (MediumCta = {}));
